/**
 * @file 状态码文件
 * @author weijiaxun <weijiaxun@baidu.com>
 */
/**
 * eop-matrix 的状态校验码规范沿用 boxjs 的校验码规范
 * 由于 eop-matrix 的实现更加上层，所以不会涉及一些较为底层的状态码
 * @see: http://bdbox.baidu.com/jssdk/scheme/specification.html#33-一级callback错误码规范
 * 基础status（状态码）含义：
 * 1xx为版本控制    （不处理）
 * 2xx为协议解析    （不处理）
 * 3xx为协议分发    （不处理）
 * 4xx为安全校验    （目前 eop-matrix 不包含鉴权，不处理）
 * 9xx为sdk错误
 */
export const LOW_EXIST = {
    status: 101,
    message: '该版本不支持此端能力'
};
export const NOT_EXIST = {
    status: 901,
    message: '不存在此端能力'
};
export const NATIVE_NOT_EXIST = {
    status: 905,
    message: '不存在对应端的 js sdk'
};
//# sourceMappingURL=status.js.map